import { Box, Typography, IconButton } from '@mui/material';
import { dynamicInvoicePageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';

type ExchangeRateDisplayProps = {
  formattedExchangeRate: string;
  onEditClick: () => void;
  disabled?: boolean;
};

export const ExchangeRateDisplay: React.FC<ExchangeRateDisplayProps> = ({
  formattedExchangeRate,
  onEditClick,
  disabled = false,
}) => {
  return (
    <Box
      {...getSelectorAttribute(dynamicInvoicePageSelectors.header.exchangeRateDisplay)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: '32px',
        gap: 1,
        cursor: disabled ? 'default' : 'pointer',
        '&:hover .exchange-rate-edit-icon': {
          opacity: 1,
        },
      }}
      onClick={() => !disabled && onEditClick()}
    >
      <Typography
        variant="subtitle2"
        color="textSecondary"
        sx={{
          fontSize: "14px",
          marginRight: 1
        }}>
        Exchange rate:
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          fontSize: "14px",
          fontWeight: 400
        }}>
        {formattedExchangeRate}
      </Typography>
      {!disabled && (
        <IconButton
          className="exchange-rate-edit-icon"
          size="small"
          sx={{ opacity: 0, transition: 'opacity 150ms', padding: 0 }}
        >
          <VyIcon icon="Pen" />
        </IconButton>
      )}
    </Box>
  );
};
